import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { getNotificationSetting, toggleNotificationSetting } from "./services/masterDataService";
import { THEME } from "./theme/themeColors";

const SEMANTIC_GREEN = "#198754";

const NOTIFICATION_KEY = "DocumentGenerationFailureEmailNotification";

const Spinner = () => (
  <div className="text-center py-4">
    <div className="spinner-border spinner-border-sm" style={{ color: THEME.primary }} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

const NotificationSettings = () => {
  const [isEnabled, setIsEnabled] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    fetchSetting();
  }, []);

  const fetchSetting = async () => {
    setLoading(true);
    try {
      const data = await getNotificationSetting(NOTIFICATION_KEY);
      setIsEnabled(!!data?.isEnabled);
    } catch (err) {
      console.error("Failed to load notification setting:", err);
      toast.error("Failed to load notification setting.");
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async () => {
    const nextValue = !isEnabled;
    setUpdating(true);
    const loadingToast = toast.loading(`${nextValue ? "Enabling" : "Disabling"} notification...`);

    try {
      await toggleNotificationSetting({
        notificationKey: NOTIFICATION_KEY,
        isEnabled: nextValue,
      });
      toast.dismiss(loadingToast);
      toast.success(`Document generation failure email notification ${nextValue ? "enabled" : "disabled"}.`);
      setIsEnabled(nextValue);
    } catch (err) {
      toast.dismiss(loadingToast);
      toast.error(
        err.response?.data?.message ||
          err.response?.data?.error ||
          "Failed to update notification setting."
      );
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="container-fluid p-0 px-1">
      <div className="card-body">
        <div className="row g-2">
          <div className="col-12 col-lg-7">
            <div className="card border" style={{ borderRadius: "6px" }}>
              <div
                className="card-header"
                style={{
                  color: THEME.onPrimary,
                  fontWeight: 600,
                  fontSize: 14,
                  padding: "6px 10px",
                  backgroundColor: THEME.primary,
                }}
              >
                Email Notification Settings
              </div>
              <div className="card-body p-3">
                {loading ? (
                  <Spinner />
                ) : (
                  <div className="d-flex align-items-center justify-content-between py-2 px-1">
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 600, color: "#212529" }}>
                        Document Generation Failure Email Notification
                      </div>
                      <div style={{ fontSize: 11, color: "#6c757d", marginTop: 2 }}>
                        When a document generation record fails to be queued or processed, an
                        alert email is sent. Disable this to stop that email without any code
                        or config deployment.
                      </div>
                    </div>
                    <button
                      className="btn btn-sm text-white fw-semibold"
                      onClick={handleToggle}
                      disabled={updating}
                      style={{
                        fontSize: "11px",
                        padding: "4px 14px",
                        whiteSpace: "nowrap",
                        backgroundColor: isEnabled ? SEMANTIC_GREEN : "#dc3545",
                        border: "none",
                      }}
                    >
                      {updating ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          style={{ width: "12px", height: "12px" }}
                        />
                      ) : isEnabled ? (
                        "Enabled — Click To Disable"
                      ) : (
                        "Disabled — Click To Enable"
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;